import React from 'react';
import './header.css';

export const Header = () => {
  return (
    <header className="site-header">
      <div className="brand">
        <span className="brand-dot" />
        <span className="brand-name">Pulse</span>
      </div>
      <h1 className="site-title">
        Heart Rate <span className="site-title-accent">Calculator</span>
      </h1>
      <div className="title-divider" aria-hidden="true" />
      <p className="site-subtitle">
        Know your zones. Train with intention.
      </p>
    </header>
  );
};
